export const REFRESH_ASSOCIATES = 'REFRESH_ASSOCIATES';
export const ADD_ASSOCIATE = 'ADD_ASSOCIATE';
export const UPDATE_ASSOCIATE = 'UPDATE_ASSOCIATE';
export const DELETE_ASSOCIATE = 'DELETE_ASSOCIATE';
export const UNLINK_ASSOCIATE = 'UNLINK_ASSOCIATE';
export const UPDATE_ASSOCIATE_NOTIFICATION_SETTINGS = 'UPDATE_ASSOCIATE_NOTIFICATION_SETTINGS';
export const GET_ASSOCIATE_NOTIFICATION_SETTINGS = 'GET_ASSOCIATE_NOTIFICATION_SETTINGS';
